import { Checkbox, FormCheckbox, type GridRenderCellParams } from '@shared/components';
import { useFormContext } from 'react-hook-form';

import { useCheckboxState } from '../hooks';
import type { QBankStructureCVForm } from '../types';
import { getCheckboxIconByType } from '../utils';

interface FormQBankStructureCVParentCheckboxProps extends GridRenderCellParams {
  disabled?: boolean;
}

export function FormQBankStructureCVParentCheckbox(
  props: Readonly<FormQBankStructureCVParentCheckboxProps>,
) {
  const { disabled: isDisabled = false, ...params } = props;
  const formContext = useFormContext();
  const name = `contentIds.${params.row.id}.isVisible`;
  const contentIds = formContext.watch('contentIds') as QBankStructureCVForm['contentIds'];

  const children = Object.entries(contentIds).reduce(
    (acc, [key, value]) => {
      if (value.parentLevelItemId === params.row.id) {
        acc[key] = value;
      }
      return acc;
    },
    {} as QBankStructureCVForm['contentIds'],
  );

  const [{ isChecked, checkboxState }] = useCheckboxState(children, name);

  return !isDisabled ? (
    <FormCheckbox
      name={name}
      value={isChecked}
      checkedIcon={getCheckboxIconByType(checkboxState)}
    />
  ) : (
    <Checkbox checked={formContext.watch(name)} disabled />
  );
}
